
    import {Component, Vue} from "vue-property-decorator";
    import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
    import ReportService from "@/services/reportService";

    @Component({
        components: {
            LayoutDefault
        },
    })

    export default class SendReport extends Vue {
        private reportService = new ReportService();
        private reportAuthData: any = {fields: {Key: ''}};
        private loading: any = false;
        private fileUploaded: any;
        private reportSuccess:any = false;
        private reportError:any = false;
        private reportErrorMessage:any = "";

        private callReport() {
            let data = new FormData();
            data.append("file", this.fileUploaded);
            this.loading = true;

            this.reportService.getReportAuth().then((result: any) => {
                this.reportAuthData = result;

                var header = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                this.$http.put(this.reportAuthData.url, this.fileUploaded, header).then(response => {
                    let backendParams = {
                        params: {
                            file: this.reportAuthData.bucketUrl+this.reportAuthData.fileName ,
                            apiUrl: process.env.VUE_APP_ROOT_API,
                            platform: this.$auth.user().platform_name
                        },
                    }

                    this.$http.get(process.env.VUE_APP_ROOT_API+'backend/index.php',backendParams).then((response:any) => {
                        if(response.body.message.indexOf('successfully') !== -1){
                            this.reportError = false;
                            this.reportSuccess = true;
                            this.loading = false;
                        }else{
                            this.reportSuccess = false;
                            this.reportError = true;
                            this.reportErrorMessage = response.body;
                            this.loading = false;
                        }
                    }, response => {
                        this.reportError = true;
                        this.loading = false;
                    });
                }, response => {
                    this.reportError = true;
                    this.loading = false;
                });
            });
        }

        private changeFile(e) {
            e.preventDefault();
            var files = e.target.files;
            this.fileUploaded = files[0];
        }
    }
